module.exports = __webpack_public_path__ + "img/image 14.f36031c5.png";